import React from "react";
import styled from "styled-components";
import VeganCover from "../assets/about-photos/vegan-cover.jpg";
import Vegan1 from "../assets/about-photos/vegan-single.jpg";
import Vegan2 from "../assets/about-photos/vegan-single-2.jpg";
import Vegan3 from "../assets/about-photos/vegan-single-3.jpg";

const About = () => {
  return (
    <AboutWrapper>
      <section className="div-wrapper">
        <div>
          <h1>About us</h1>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Temporibus,
            hic.
          </p>
        </div>

        <div className="parent-grid mb-4">
          <div className="grid-item-1">
            <img src={Vegan1} className="img-size" alt="img" />
            <span>Lorem ipsum dolor sit.</span>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Explicabo non magni iusto aliquid.
            </p>
          </div>

          <div className="grid-item-1">
            <img src={Vegan2} className="img-size" alt="img" />
            <span>Lorem ipsum dolor sit.</span>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Explicabo non magni iusto aliquid.
            </p>
          </div>

          <div className="grid-item-1">
            <img src={Vegan3} className="img-size" alt="img" />
            <span>Lorem ipsum dolor sit.</span>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Explicabo non magni iusto aliquid.
            </p>
          </div>
        </div>

        <div>
          <img src={VeganCover} className="banner" alt="" />
        </div>

        <div className="footer-grid mt-4">
          <div className="grid-item-2">
            <span>Pizza Basics</span>
          </div>

          <div className="grid-item-2 mb-5">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Assumenda, magni?Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Assumenda, magni?
            </p>
          </div>

          <div className="grid-item-2">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Assumenda, magni?Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Assumenda, magni?
            </p>
          </div>
        </div>
      </section>
    </AboutWrapper>
  );
};

const AboutWrapper = styled.div`
  .div-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  h1 {
    text-align: center;
    margin-top: 100px;
    font-size: 34px;
    color: var(--productTitle);
    letter-spacing: 1px;
    font-weight: lighter;
  }

  p {
    color: var(--checkout-product-descr);
    font-size: 15px;
    width: 100%;
    text-align: center;
  }

  span {
    font-size: 16px;
    color: var(--productTitle);
    font-weight: bold;
  }

  .banner {
    width: 1920px;
    height: 300px;
    object-fit: cover;
  }

  .parent-grid {
    gap: 0px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    width: var(--smallWidth);
    max-width: var(--fullWidth);
    margin: 100px auto;
  }

  .parent-grid img {
    width: 370px;
    height: 280px;
    object-fit: contain;
  }

  .grid-item-1 {
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .grid-item-1 span,
  p {
    padding: 10px;
  }

  .grid-item-2 {
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .parent-grid-2 {
    display: grid;
    width: var(--smallWidth);
    max-width: var(--fullWidth);
  }
  .footer-grid {
    width: var(--smallWidth);
    max-width: var(--fullWidth);
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }

  @media screen and (max-width: 650px) {
    .banner {
      width: 100%;
    }
  }
`;

export { About as default };
